import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem, DropdownButton } from 'react-bootstrap';
import FormattedCurrency from '../../FormattedCurrency';
import { priceShape } from '../registrationHelpers';

const PriceOptionsDropdown = ({ price, priceOptions, disabled, onPriceChanged }) => {
  const showWarning = !price || !price.id;
  return priceOptions && priceOptions.length > 0 ? (
    <DropdownButton
      bsSize="sm"
      bsStyle="default"
      noCaret
      className={showWarning ? 'btn-light-warning' : ''}
      id="PriceOptionsDropdown-button"
      disabled={disabled}
      title={<i className="fa fa-exclamation" />}
    >
      {priceOptions.map(option => (
        <MenuItem
          key={option.id}
          onClick={() => onPriceChanged(option)}
          active={price && option.id === price.id}
        >
          <div>
            <strong>
              <FormattedCurrency value={option.amount} />
            </strong>
          </div>
        </MenuItem>
      ))}
    </DropdownButton>
  ) : null;
};

PriceOptionsDropdown.propTypes = {
  price: priceShape,
  priceOptions: PropTypes.arrayOf(priceShape),
  disabled: PropTypes.bool,
  onPriceChanged: PropTypes.func.isRequired,
};
PriceOptionsDropdown.defaultProps = {
  price: null,
  priceOptions: null,
  disabled: false,
};
export default PriceOptionsDropdown;
